(() => {
  const init = (root = document) => {
    root.querySelectorAll('a[href]').forEach(link => {
      const target = new URL(link.href, location.href);
      if (target.origin === location.origin && target.hash && document.getElementById(target.hash.slice(1))) {
        link.setAttribute('href', target.hash);
      }
    });
    root.querySelectorAll('.menu-toggle:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const close = () => { menu.hidden = true; button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', () => { const opening = button.getAttribute('aria-expanded') !== 'true'; button.setAttribute('aria-expanded', String(opening)); menu.hidden = !opening; });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && !menu.hidden) { close(); button.focus(); } });
      window.matchMedia('(min-width: 901px)').addEventListener('change', event => { if (event.matches) close(); });
    });
    root.querySelectorAll('[data-service]:not([data-ready]),[data-interest]:not([data-ready])').forEach(link => {
      link.dataset.ready = 'true';
      link.addEventListener('click', () => {
        const contact = document.querySelector('#contact');
        if (contact) {
          if (link.dataset.service) contact.querySelector('[data-service-select]').value = link.dataset.service;
          contact.querySelector('[data-engagement-input]').value = link.dataset.interest || 'General inquiry';
        } else {
          const url = new URL(link.href, location.href);
          if(link.dataset.service)url.searchParams.set('service',link.dataset.service);
          if(link.dataset.interest)url.searchParams.set('interest',link.dataset.interest);
          link.href=url.href;
        }
      });
    });
  };
  init();
  const query=new URLSearchParams(location.search);
  const select=document.querySelector('[data-service-select]');
  if(select && [...select.options].some(o=>o.value===query.get('service')))select.value=query.get('service');
  const engagement=document.querySelector('[data-engagement-input]');
  if(engagement && query.has('interest'))engagement.value=query.get('interest').slice(0,200);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => { const details=event.target.closest('details');if(details)details.open=true; });
  const success=document.querySelector('.form-success');if(success)success.focus();
})();
